import React from 'react'

import AggregateShellComponent from "../../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    value: any

    type                        : 'list' | 'table' | 'gantt' | 't-list'
    aggregateFunction           : string

    isFirstInBlock              : boolean
    isLastInBlock               : boolean

    onChangeAggregateFunction   : callback          //for more button
}

export default function AggregateCost(options: any[], props: Props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const value = isValid ? props.value : null;

    const currencyMark = gd.const.currency[gd.company.financeCurrency].symbol;
    const valueLabel = gd.utils.Format.number(value,2,true);

    let noDataLabel;
    switch (props.aggregateFunction) {
        case gd.const.aggregate.type.SUM:
            noDataLabel = '0';
            break;
        default:
            noDataLabel = gd.const.aggregate.label[props.aggregateFunction];
            break;
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} hint={currencyMark + ' ' + valueLabel} {...props}>
            {isValid &&
            <React.Fragment>
                <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>
                <div className="aggregate-value aggregate-number">{currencyMark} {valueLabel}</div>
            </React.Fragment>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}